<script>
import axios from "axios";
import { Pie, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";

export default {
  extends: Pie,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await axios
      .get("https://scathachbot.xyz/api/automation")
      .then((response) => {
        this.chartData = response.data;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });

    const user = this.chartData;

    let labelList = ["Rule34", "Danbooru", "Gelbooru", "Hypnohub", "Konachan", "Realbooru", "Tbib",
      "Xbooru", "Yandere", "Autohentai", "Autoporn", "Autofurry", "Autoirl", "Automemes", "Autoreddit",
      "Autofgo", "Autovtuber"];

    let backgroundList = [getRandomColor(), getRandomColor(), getRandomColor(), getRandomColor(), 
      getRandomColor(), getRandomColor(), getRandomColor(), getRandomColor(), getRandomColor(), 
      getRandomColor(), getRandomColor(), getRandomColor(), getRandomColor(), getRandomColor(), 
      getRandomColor(), getRandomColor(), getRandomColor()];

    let dataList = [user.names, user.danbo, user.gel, user.hyp, user.kona, user.realbo, user.tbib,
      user.xbo, user.yande, user.autohentai, user.autoporn, user.autofurry, user.autoirl, user.automeme,
      user.autoreddit, user.autofgo, user.vtuber];

    this.chartData = {
      //get all keys from user object
      //labels: Object.keys(user),
      labels: labelList,
      datasets: [
        {
          backgroundColor: backgroundList,
          data: dataList
        }
      ]
    };
  }
};
</script>